module.exports = __webpack_public_path__ + "static/img/7.8f3fc14.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/7.png
// module id = +78M
// module chunks = 0